import portals from '../../../enums/portalsEnum'

const WELCOME = 'livret_accueil'
const RESIDENCE_WELCOME_URL = 'https://residence.youfirst.co/livret/Bienvenuechezvous/index.html#/'
const RESIDENCE_REPARATION_URL = 'https://residence.youfirst.co/livret/Bienvenuechezvous/index.html#/page/a-votre-charge-a-la-charge-de-youfirst-residence'
export const REPARATIONS = 'guide_reparations'
export const VISUEL_WELCOME ='visuel_livret_accueil'
export const VISUEL_REPARATIONS= 'visuel_guide_des_reparations'
export const convertFileList = (response: any) => {
    return [
        {
            name: WELCOME,
            translation: 'requests.welcome',
            img: response[VISUEL_WELCOME] === ''? 'img/requests/welcome.png' : response[VISUEL_WELCOME] ,
            url: process.env.REACT_APP_TARGET === portals.campus ? response[WELCOME] : RESIDENCE_WELCOME_URL
        },
        {
            name: REPARATIONS,
            translation: 'requests.reparations',
            img: response[VISUEL_REPARATIONS] === '' ? 'img/requests/reparations.png' : response[VISUEL_REPARATIONS],
            url: process.env.REACT_APP_TARGET === portals.campus ? response[REPARATIONS] : RESIDENCE_REPARATION_URL
        }
    ]

}
